import React, { useState, useRef, useEffect } from "react";
import { FormFeedback, Input, FormGroup } from "reactstrap";

const MultiSelectDropDown = ({
  options = [],
  placeholder = "Search...",
  value = [],
  onChange,
  name,
  isSearchable = true,
  error,
  isMulti = false,
}) => {
  const [dropdown, setDropdown] = useState({
    query: "",
    open: false,
  });
  const wrapperRef = useRef(null);

  const selectedValues = isMulti ? value : [value];

  const selectedOptions = options?.filter((o) =>
    selectedValues.includes(o.value),
  );

  const filteredOptions = options?.filter((item) =>
    item.label.toLowerCase().includes(dropdown.query.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setDropdown((prev) => ({ ...prev, open: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!dropdown.open) {
      const labels = selectedOptions.map((o) => o.label).join(", ");
      setDropdown((prev) => ({
        ...prev,
        query: labels,
      }));
    }
  }, [value, options]);

  const toggleSelect = (item) => {
    let newValues;

    if (selectedValues.includes(item.value)) {
      newValues = selectedValues.filter((v) => v !== item.value);
    } else {
      newValues = [...selectedValues, item.value];
    }

    onChange({
      target: {
        name,
        value: isMulti ? newValues : item.value,
        labels: options
          ?.filter((o) => newValues.includes(o.value))
          .map((o) => o.label),
      },
    });

    setDropdown((prev) => ({ ...prev, query: "" }));
  };

  return (
    <FormGroup>
      <div ref={wrapperRef} style={{ position: "relative" }}>
        <Input
          type="text"
          name={name}
          placeholder={placeholder}
          value={
            dropdown.open
              ? dropdown.query
              : selectedOptions.map((o) => o.label).join(", ")
          }
          onFocus={() =>
            setDropdown((prev) => ({
              ...prev,
              open: true,
              query: "",
            }))
          }
          onChange={(e) =>
            setDropdown({
              query: e.target.value,
              open: true,
            })
          }
          autoComplete="off"
          readOnly={!isSearchable}
          invalid={!!error}
          style={{
            backgroundColor: "#fff",
            paddingRight: "30px",
            cursor: isSearchable ? "text" : "pointer",
          }}
        />

        <span
          className="dropdown-icon"
          onClick={() => setDropdown((prev) => ({ ...prev, open: !prev.open }))}
        >
          <i className="fa fa-angle-down" />
        </span>

        {dropdown.open && (
          <div className="dropdown-menu show w-100 mt-1 searchable-dropdown-menu">
            {filteredOptions.length ? (
              filteredOptions.map((item) => (
                <button
                  key={item.value}
                  type="button"
                  className={`dropdown-item ${
                    selectedValues.includes(item.value) ? "active" : ""
                  }`}
                  onClick={() => toggleSelect(item)}
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={selectedValues.includes(item.value)}
                    className="mr-2"
                  />
                  {item.label}
                </button>
              ))
            ) : (
              <span className="dropdown-item text-muted">No results found</span>
            )}
          </div>
        )}
      </div>
      {error && <FormFeedback className="d-block">{error}</FormFeedback>}
    </FormGroup>
  );
};

export default MultiSelectDropDown;
